import type { NavigationEntry } from "@positive/ui";
import "@ui5/webcomponents-icons/dist/account.js";
import "@ui5/webcomponents-icons/dist/action-settings.js";
import "@ui5/webcomponents-icons/dist/currency.js";
import "@ui5/webcomponents-icons/dist/customer-and-contacts.js";
import "@ui5/webcomponents-icons/dist/database.js";
import "@ui5/webcomponents-icons/dist/group-2.js";
import "@ui5/webcomponents-icons/dist/org-chart.js";
import "@ui5/webcomponents-icons/dist/project-definition-triangle.js";

import { financePermissions } from "./permissions";

/** Master Data A entries of the navigation registry (group `masterData`, plan module `md`, always on). */
export const masterDataFinanceNavigation: readonly NavigationEntry[] = [
  {
    key: "md.accounts",
    labelKey: "nav.chartOfAccounts",
    icon: "account",
    path: "/md/accounts",
    permission: financePermissions.accountView,
  },
  {
    key: "md.accountGroups",
    subGroup: "setupTools",
    labelKey: "nav.accountGroups",
    icon: "group-2",
    path: "/md/account-groups",
    permission: financePermissions.accountGroupView,
  },
  {
    key: "md.costCenters",
    labelKey: "nav.costCenters",
    icon: "org-chart",
    path: "/md/cost-centers",
    permission: financePermissions.costCenterView,
  },
  {
    key: "md.projects",
    labelKey: "nav.projects",
    icon: "project-definition-triangle",
    path: "/md/projects",
    permission: financePermissions.projectView,
  },
  {
    key: "md.currencies",
    labelKey: "nav.currencies",
    icon: "currency",
    path: "/md/currencies",
    permission: financePermissions.currencyView,
  },
  {
    key: "md.parties",
    labelKey: "nav.parties",
    icon: "customer-and-contacts",
    path: "/md/parties",
    permission: financePermissions.partyView,
  },
  {
    key: "md.partySettings",
    subGroup: "setupTools",
    labelKey: "nav.partySettings",
    icon: "action-settings",
    path: "/md/party-settings",
    permission: financePermissions.partyView,
  },
];
